import {EDiffusionExpressCode} from "@/model/User/EDiffusionExpressCode";
import {IUserImported} from "@/store/modules/userDiffusionExpressModule";

// what diffusion express did with each csv line / locker resident, grouping mayordomo's code_import values
export enum EDiffusionExpressOperation {
  INVITED = 'invited',
  CREATED = 'created',
  MOVED = 'moved',
  RESTORED = 'restored',
  UNCHANGED = 'unchanged',
  DEACTIVATED = 'deactivated',
  NOT_DEACTIVATED = 'notDeactivated',
  NOT_PROCESSED = 'notProcessed',
  ERROR = 'error',
}

export const DIFFUSION_EXPRESS_OPERATIONS: EDiffusionExpressOperation[] = [
  EDiffusionExpressOperation.INVITED,
  EDiffusionExpressOperation.CREATED,
  EDiffusionExpressOperation.MOVED,
  EDiffusionExpressOperation.RESTORED,
  EDiffusionExpressOperation.UNCHANGED,
  EDiffusionExpressOperation.DEACTIVATED,
  EDiffusionExpressOperation.NOT_DEACTIVATED,
  EDiffusionExpressOperation.NOT_PROCESSED,
  EDiffusionExpressOperation.ERROR,
];

export const DIFFUSION_EXPRESS_OPERATION_COLORS: {[key in EDiffusionExpressOperation]: string} = {
  [EDiffusionExpressOperation.INVITED]: 'light-green',
  [EDiffusionExpressOperation.CREATED]: 'green',
  [EDiffusionExpressOperation.MOVED]: 'blue',
  [EDiffusionExpressOperation.RESTORED]: 'indigo',
  [EDiffusionExpressOperation.UNCHANGED]: 'teal',
  [EDiffusionExpressOperation.DEACTIVATED]: 'orange',
  [EDiffusionExpressOperation.NOT_DEACTIVATED]: 'grey',
  [EDiffusionExpressOperation.NOT_PROCESSED]: 'amber',
  [EDiffusionExpressOperation.ERROR]: 'red',
};

const OPERATION_BY_CODE: {[code: number]: EDiffusionExpressOperation} = {
  [EDiffusionExpressCode.NEW_EMAIL]: EDiffusionExpressOperation.INVITED,
  [EDiffusionExpressCode.UPDATED]: EDiffusionExpressOperation.MOVED,
  [EDiffusionExpressCode.RESTORED]: EDiffusionExpressOperation.RESTORED,
  [EDiffusionExpressCode.NOT_MODIFIED]: EDiffusionExpressOperation.UNCHANGED,
  [EDiffusionExpressCode.DEACTIVATED]: EDiffusionExpressOperation.DEACTIVATED,
  [EDiffusionExpressCode.NOT_DEACTIVATED_ACTIVE_ORDERS]: EDiffusionExpressOperation.NOT_DEACTIVATED,
  120: EDiffusionExpressOperation.NOT_PROCESSED,
  199: EDiffusionExpressOperation.NOT_PROCESSED,
};

export function diffusionExpressOperation(row: IUserImported): EDiffusionExpressOperation {
  // a new email is only created as a user when overriding the locker users; otherwise it is invited, as always
  if (row.code_import === EDiffusionExpressCode.NEW_EMAIL && row.detail === 'created') {
    return EDiffusionExpressOperation.CREATED;
  }
  return OPERATION_BY_CODE[row.code_import] || EDiffusionExpressOperation.ERROR;
}

// the csv header line (line 0) only matters when it failed
export function isDiffusionExpressHeaderOk(row: IUserImported): boolean {
  return row.line === 0 && row.code_import === EDiffusionExpressCode.HEADER_OK;
}
